<div class="row">
@for(section of sections; track section){
  <div class="col col-12 col-lg-{{ section.width * 4 }}">
    <app-cards-basic title="{{ section.translations[currentLanguage].title }}">
      @if(section.editor_blocks.length > 0){
        <app-section-detail
          [sectionID]="section"
          [contentBlockInput]="section.editor_blocks"
          [selectedPeriod]="selectedPeriod()"
          [selectedBenchmark]="selectedBenchmark()">
        </app-section-detail>
      } @else {
        <app-section-detail
          [sectionID]="section"
          [selectedPeriod]="selectedPeriod()"
          [selectedBenchmark]="selectedBenchmark()">
        </app-section-detail>
      }
    </app-cards-basic>
  </div>
}
</div>

